import { useQuery } from '@apollo/client';
import { cmsBlocks, cmsBlocksVariables } from 'src/queries/__generated__/cmsBlocks';
import getCmsBlocks from 'src/queries/getCmsBlocks.graphql';
import { useDeps } from 'src/hooks/useDeps';

export const useDeliveryCms = () => {
    const { data: deliveryData } = useQuery<cmsBlocks, cmsBlocksVariables>(getCmsBlocks, {
        variables: { identifiers: ['delivery-uk-ireland'] },
        ssr: useDeps().env.SSR_GQL,
        errorPolicy: 'ignore',
    });

    const { data: internationalData } = useQuery<cmsBlocks, cmsBlocksVariables>(getCmsBlocks, {
        variables: { identifiers: ['international-delivery'] },
        ssr: useDeps().env.SSR_GQL,
        errorPolicy: 'ignore',
    });

    const { data: dispatchData } = useQuery<cmsBlocks, cmsBlocksVariables>(getCmsBlocks, {
        variables: { identifiers: ['24-hr-dispatch'] },
        ssr: useDeps().env.SSR_GQL,
        errorPolicy: 'ignore',
    });

    const { data: servicesData } = useQuery<cmsBlocks, cmsBlocksVariables>(getCmsBlocks, {
        variables: { identifiers: ['delivery-customer-services'] },
        ssr: useDeps().env.SSR_GQL,
        errorPolicy: 'ignore',
    });

    if (
        !deliveryData?.cmsBlocks?.items ||
        !internationalData?.cmsBlocks?.items ||
        !dispatchData?.cmsBlocks?.items ||
        !servicesData?.cmsBlocks?.items
    )
        return {
            delivery: undefined,
            international: undefined,
            dispatch: undefined,
            services: undefined,
            loading: true,
        };

    return {
        delivery: deliveryData.cmsBlocks?.items[0]?.content || '',
        international: internationalData.cmsBlocks?.items[0]?.content || '',
        dispatch: dispatchData.cmsBlocks?.items[0]?.content || '',
        services: servicesData.cmsBlocks?.items[0]?.content || '',
        loading: false,
    };
};
